import { FabricAuthState } from '@common/Fabric/constants';

import { ReadOnlySection } from './ReadOnlyFabricView';

// Generic authState -> display mappings shared by every provider's setup form
// and read-only view. None of this is provider-specific — only the `provider`
// display name passed in varies per call site.

export const getAuthBadge = (authState: FabricAuthState): ReadOnlySection['badge'] => {
  switch (authState) {
    // validity is still being verified — don't assert success/error yet
    case FabricAuthState.Loading:
      return undefined;
    case FabricAuthState.OAuthValid:
    case FabricAuthState.AdminWithValidCreds:
    case FabricAuthState.NonAdminWithValidCreds:
      return { label: 'Success', variant: 'success' };
    case FabricAuthState.OAuthExpired:
    case FabricAuthState.AdminWithExpiredCreds:
    case FabricAuthState.NonAdminWithExpiredCreds:
      return { label: 'Re-auth Required', variant: 'error' };
    default:
      return { label: 'Auth Pending', variant: 'error' };
  }
};

// Whether AuthStateCard actually renders something for this authState — callers use this to
// decide whether to show a containing section/wrapper at all, since <AuthStateCard /> itself is
// always a truthy element even when it renders null internally.
export const hasAuthStateCard = (authState: FabricAuthState | null): boolean =>
  authState === FabricAuthState.Loading ||
  authState === FabricAuthState.OAuthValid ||
  authState === FabricAuthState.OAuthExpired ||
  authState === FabricAuthState.OAuthNotConnected ||
  authState === FabricAuthState.AdminWithExpiredCreds ||
  authState === FabricAuthState.NonAdminWithExpiredCreds;
